import {createSelector} from '@ngrx/store';

import * as fromApprovalflowStages from './approval-flow-stages.reducer';
import {AppState} from 'src/app/store/reducers';
import {ApprovalFlow} from '../approval-flow/approval-flow.model';


export const currentState = (state: AppState) => (state[fromApprovalflowStages.approvalFlowStagesesFeatureKey]);

export const selectAllApprovalFlowStages = createSelector(currentState, fromApprovalflowStages.selectAll);

export const selectTotalApprovalFlowStages = createSelector(currentState, fromApprovalflowStages.selectTotal);

export const selectModifiedApprovalFlowStages = createSelector(selectAllApprovalFlowStages, (approvalFlowStages) => {
  return approvalFlowStages.map((stages) => {
    return {
      ...stages,
      stageIsEndingmod:stages?.stageIsEnding ?  "Yes" : "No",
      stageIsStartingmdo:stages?.stageIsStarting ?  "Yes" : "No",
      stageDesignationMod:stages?.stageDesignation?.designationShortForm,
      successorStageMod: stages?.successorStage?.stageName
    };
  });
});


export const selectModidifiedApprovalByflowUniqueId = (flowUniqueId: string) => createSelector(
  selectModifiedApprovalFlowStages, (component:ApprovalFlow []) => {
    return component.filter((comp) => comp?.flowUniqueId === flowUniqueId );
  });
